var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticClass:"saved-input",attrs:{"placeholder":""},on:{"change":function($event){return _vm.handleInput()}}})}
var staticRenderFns = []

export { render, staticRenderFns }